import { render, staticRenderFns } from "./AdminStudentUpdate.vue?vue&type=template&id=1b215293"
import script from "./AdminStudentUpdate.vue?vue&type=script&lang=js"
export * from "./AdminStudentUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports